var modules_2904d714 = {"form":"Calculator_module_form__b1982e4c","purposeSelect":"Calculator_module_purposeSelect__b1982e4c"};
import "../../../../assets/esm/components/SelectionCalculator/components/Calculator/Calculator~BoH_nJ75.css";

export { modules_2904d714 as default };
//# sourceMappingURL=Calculator.module.scss.js.map
